import httpClient from './httpClient';

interface AuditLogParams {
    page?: number;
    per_page?: number;
    search?: string;
}

export const getAuditLogs = async (params: AuditLogParams) => {
    const response = await httpClient.get('/crm/audit-logs', { params });
    return response.data;
};
